import { BaseBlockProps, ColorId } from '../../defs/block';

export type MagicBunniesBlockID = 'magicBunnies';

export type MagicBunniesBlockType = 'magicBunnies';

export type MagicBunniesBlockProps = {
  type: MagicBunniesBlockType;
} & BaseBlockProps;

export const magicBunniesBlockProps: Record<
  MagicBunniesBlockID,
  MagicBunniesBlockProps
> = {
  magicBunnies: {
    id: 'mb',
    type: 'magicBunnies',
    immobile: true,
    width: 2,
    height: 2,
    options: [{ count: 4 }, { count: 3 }, { count: 2 }, { count: 1 }],
    optionType: 'list',
    noEditorOptions: true,
  },
};
